import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React from "react"
import "./section-link-grid-v2.scss"

const SectionLinkGridV2 = ({ linkSubTitle, links, text, title }) => {
  return (
    <section className="section-link-grid-v2">
      <div className="container-v2">
        <div className="section-link-grid-v2--header">
          {title && (
            <h2 className="section-link-grid-v2--title">
              <TextLockupV2>{title}</TextLockupV2>
            </h2>
          )}

          {text?.childrenMarkdownRemark?.[0]?.html && (
            <div
              className="section-link-grid-v2--text"
              dangerouslySetInnerHTML={{
                __html: text.childrenMarkdownRemark[0].html,
              }}
            />
          )}
        </div>

        <div className="section-link-grid-v2--content-body">
          {linkSubTitle && (
            <h3 className="section-link-grid-v2--sub-title">{linkSubTitle}</h3>
          )}
          {links && links.length > 0 && (
            <div className="section-link-grid-v2--links">
              {links.map(link => (
                <p className="section-link-grid-v2--link-wrapper" key={link.id}>
                  <a className="section-link-grid-v2--link" href={link.link}>
                    {link.title}
                  </a>
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

SectionLinkGridV2.propTypes = {
  linkSubTitle: PropTypes.string.isRequired,
  // array of title and link/url objects
  links: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    })
  ).isRequired,
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default SectionLinkGridV2
